import { FunctionComponent } from "react";
import { ReactComponent as Dot } from '../../../../assets/dot-primary.svg';
import { SoftwareFeature } from '../../../../utils/types/SoftwareFeaturesTypes';
import { SOFTWARE_FEATURES_CONFIG } from '../../../../constants/softwareFeatures';

const SoftwareFeatures: FunctionComponent = () => {
    return (
        <section className={`w-full p-10 mt-14 ${SOFTWARE_FEATURES_CONFIG.backgroundStyle}`}>
            <FeaturesTitle />
            <FeaturesGrid />
        </section>
    );
};

const FeaturesTitle: FunctionComponent = () => (
    <h2 className="text-4xl tracking-wider font-sans font-semibold mb-12 text-left">
        {SOFTWARE_FEATURES_CONFIG.title}
    </h2>
);

const FeaturesGrid: FunctionComponent = () => (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-10">
        {SOFTWARE_FEATURES_CONFIG.features.map(feature => (
            <FeatureItem key={feature.id} feature={feature} />
        ))}
    </div>
);

const FeatureItem: FunctionComponent<{ feature: SoftwareFeature }> = ({ feature }) => (
    <div className="flex flex-col items-center text-center">
        <FeatureIcon />
        <FeatureText text={feature.text} />
    </div>
);

const FeatureIcon: FunctionComponent = () => (
    <Dot height={20} width={20} className="mb-4 text-primary" />
);

const FeatureText: FunctionComponent<{ text: string }> = ({ text }) => (
    <p className="text-sm leading-tight">{text}</p>
);

export default SoftwareFeatures;


